import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import clsx from 'clsx';
function _TrackLightCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: "M6 21V3M10 4l2.023 2.184a.15.15 0 0 1 0 .204l-1.851 1.998a.15.15 0 0 0 .073.248l8.182 2.078c.151.038.151.252 0 .29l-8.054 2.046a.15.15 0 0 0-.034.278l3.652 1.97a.15.15 0 0 1 0 .265l-3.719 2.006a.15.15 0 0 0 .012.27L15.294 20" }) }) });
}
const TrackLightCustom = forwardRef(_TrackLightCustom);
export { TrackLightCustom };
